module.exports = __webpack_public_path__ + "static/img/serveone-renewal-thumb.7a88583.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/serveone-renewal-thumb.jpg
// module id = 1xJW
// module chunks = 0